import $ from 'jquery';
import jQueryBridget from 'jquery-bridget';
import Flickity from 'flickity';
jQueryBridget('flickity', Flickity, $);

$('.js-flickity').each((index, flickity) => {
  $(flickity).flickity({
    arrowShape:
      'M68.144 0c2.071 0 3.746 1.7 3.746 3.772 0 .997-.396 1.943-1.099 2.646L27.168 50.04 70.79 93.636a3.77 3.77 0 0 1-.089 5.319 3.776 3.776 0 0 1-5.216 0L19.203 52.686a3.783 3.783 0 0 1 0-5.319L65.485 1.1A3.738 3.738 0 0 1 68.144 0z',
    cellAlign: 'left',
    contain: true,
    draggable: true,
    pageDots: false,
    prevNextButtons: true,
    wrapAround: true,
  });
});
